import React, { Component } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import AOS from "aos"
import "aos/dist/aos.css"
import NewsStrip from "../components/news-strip"
import MetroFares from "../components/metro-fares"

class ServiceBR5Page extends Component {
  componentDidMount() {
    AOS.init()
    window.addEventListener("load", AOS.refresh)
    // @NOTE: Hack to force AOS to work :(
    window.setTimeout(AOS.refresh, 1000)
  }

  componentDidUpdate() {
    AOS.refresh()
  }

  render() {
    return (
      <Layout>
        <SEO
          title="BR5"
          description="View route information and buy your ticket for the BR5 service operated by Tetley's Coaches."
        />
        <div className="block-services inner-body-bg">
          <div className="body gutter page-content-parent">
            <div className="text-center">
              <h1 className="page-content-heading">BR5 service</h1>
              <p>Church Lane, Micklefield - Brigshaw High School</p>
              <p>Brigshaw High School - Church Lane, Micklefield</p>
            </div>
          </div>

          <div className="body gutter page-content-parent">
            <div className="page-content">
              <div className="page-content__text">
              <h2>Route</h2>
                <p style={{ margin: '15px 0'}}>This service will pick up/set down at all regular bus stops along the following route:</p>
                <h3 style={{ margin: '10px 0'}}>AM route</h3>
                <iframe
                  title="BR5 AM route map"
                  className="route-map"
                  src="https://www.google.com/maps/d/embed?mid=1t2exXD_IOx5TlO4YshjpqeKVDdNv2JU&ehbc=2E312F"
                  width="100%"
                  height="480"
                ></iframe>
                <p>
                  <strong>Towards</strong> Brigshaw High School
                </p>
                <p>
                From Church Lane, Great North Road, Selby Road, Leeds Road, Gibson Lane, High
Street, Cross Hills, Butt Hill, Brigshaw Lane.
                </p>

                <h3 style={{ margin: '10px 0'}}>PM route</h3>
                <iframe
                  title="BR5 PM route map"
                  className="route-map"
                  src="https://www.google.com/maps/d/embed?mid=13c2cyGHLBzlnp_6LvRw6fvYNMPYRqzI&ehbc=2E312F"
                  width="100%"
                  height="480"
                ></iframe>
                <p>
                  <strong>From</strong> Brigshaw High School
                </p>
                <p>
                From Brigshaw Lane, Butt Hill, Cross Hills, High Street, Gibson Lane, Leeds Road,
Selby Road, Great North Road, Church Lane
                </p>
              </div>
              <div className="page-content__text">
                <h2>Timetable</h2>
                <table className="timetable">
                  <thead>
                    <tr>
                      <th colSpan="3">Morning</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Micklefield Church Lane</td>
                      <td>DEP</td>
                      <td>0740</td>
                    </tr>
                    <tr>
                      <td>Micklefield Station</td>
                      <td>DEP</td>
                      <td>0743</td>
                    </tr>
                    <tr>
                      <td>Selby Road / Ridge Road Roundabout</td>
                      <td>DEP</td>
                      <td>0750</td>
                    </tr>
                    <tr>
                      <td>Gibson Lane</td>
                      <td>DEP</td>
                      <td>0759</td>
                    </tr>
                    <tr>
                      <td>Butt Hill Brigshaw Lane</td>
                      <td>DEP</td>
                      <td>0803</td>
                    </tr>
                    <tr>
                      <td>Brigshaw High School</td>
                      <td>ARR</td>
                      <td>0810</td>
                    </tr>
                  </tbody>
                </table>

                <table className="timetable">
                  <thead>
                    <tr>
                      <th colSpan="3">Afternoon</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Brigshaw High School</td>
                      <td>DEP</td>
                      <td>1515</td>
                    </tr>
                    <tr>
                      <td>Kippax Cross Hills</td>
                      <td>DEP</td>
                      <td>1520</td>
                    </tr>
                    <tr>
                      <td>Gibson Lane</td>
                      <td>DEP</td>
                      <td>1524</td>
                    </tr>
                    <tr>
                      <td>Rutland Close</td>
                      <td>DEP</td>
                      <td>1526</td>
                    </tr>
                    <tr>
                      <td>Micklefield</td>
                      <td>ARR</td>
                      <td>1545</td>
                    </tr>
                  </tbody>
                </table>

                <MetroFares />
              </div>
            </div>
          </div>
        </div>

        <NewsStrip />
      </Layout>
    )
  }
}

export default ServiceBR5Page
